"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var OTAModule = /** @class */ (function (_super) {
    __extends(OTAModule, _super);
    function OTAModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询门店省份列表
     *
     * @param channelId 渠道Id
     */
    OTAModule.prototype.queryHotelProvinces = function (channelId, token) {
        return this.gatewayClient.queryXbedHotelProvinces(channelId, token);
    };
    /**
     * 查询门店城市列表
     * @param channelId 渠道id
     * @param province 省份
     */
    OTAModule.prototype.queryHotelCities = function (channelId, province, token) {
        return this.gatewayClient.queryXbedHotelCities(channelId, province, token);
    };
    /**
     * 查询门店列表
     *
     * @param channelId 渠道Id (必传)
     * @param city 城市
     * @param page
     * @param rows 每页数量
     * @param xbedHotelId 门店ID
     * @param xbedHotelName 门店名称
     * @param token
     */
    OTAModule.prototype.queryHotelList = function (channelId, city, page, rows, xbedHotelId, xbedHotelName, token) {
        return this.gatewayClient.getChannelHotelList(channelId, city, page, rows, xbedHotelId, xbedHotelName, token);
    };
    /**
     * 查询未绑定xbed酒店门店列表
     *
     * @param channelId 渠道Id
     * @param city 城市
     * @param province 省份
     */
    OTAModule.prototype.queryHotelListWithUnbind = function (channelId, city, province, token) {
        return this.gatewayClient.queryXbedHotelWithUnbind(channelId, city, province, token);
    };
    /**
     * 新增门店
     * @param xbedHotelId 门店Id
     * @param operatorName 操作人
     */
    OTAModule.prototype.addHotel = function (xbedHotelId, operatorName, token) {
        return this.gatewayClient.addChannelHotel(xbedHotelId, operatorName, token);
    };
    /**
     * 删除门店
     * @param xbedHotelId 门店Id
     * @param token
     */
    OTAModule.prototype.removeHotel = function (xbedHotelId, token) {
        return this.gatewayClient.deleteXbedHotel(xbedHotelId, token);
    };
    /**
     * 查询门店详情基本信息
     * @param hotelId 门店Id
     * @param token
     */
    OTAModule.prototype.findHotel = function (channelHotelId, token) {
        return this.gatewayClient.getChannelHotelInfo(channelHotelId, token);
    };
    /**
     * 编辑门店
     * @param channelHotelId 	门店Id（必传）
     * @param coverImage 	封面图
     * @param status 状态 S01上线 S02下线
     * @param token
     */
    OTAModule.prototype.updateHotel = function (params, token) {
        return this.gatewayClient.updateChannelHotel(params, token);
    };
    /**
     * 编辑门店介绍
     * @param params
     * @param channelHotelId 	门店Id（必传）
     * @param introduction 门店介绍
     * @param token
     */
    OTAModule.prototype.updateHotelIntro = function (params, token) {
        return this.gatewayClient.updateHotelIntro(params, token);
    };
    /**
     * 查询全部房型列表
     * @param channelHotelId 门店id
     * @param dockingStatus 打包状态 状态 S01:有效,S02:失效,S03:删除
     * @param hotelName 门店名称(查询)
     * @param roomTypeName 房型名称(查询)
     * @param page 页
     * @param rows 行数
     * @param token
     */
    OTAModule.prototype.queryAllRoomTypeList = function (channelId, status, hotelName, name, page, rows, token) {
        return this.gatewayClient.queryAllRoomTypeList(channelId, status, hotelName, name, page, rows, token);
    };
    /**
     * 查询单个门店的房型列表
     * @param channelHotelId 门店Id
     * @param name 房型名称
     * @param page 页码
     * @param rows 每页数量
     * @param status 状态（S01 上线 S02 下线）
     * @param token
     */
    OTAModule.prototype.getRoomTypeList = function (params, token) {
        return this.gatewayClient.getRoomTypeList(params, token);
    };
    /**
     * 获取房型信息
     * @param roomTypeId 房型Id
     * @param token
     */
    OTAModule.prototype.queryRoomTypeInfo = function (roomTypeId, token) {
        return this.gatewayClient.getInfoRoom(roomTypeId, token);
    };
    /**
     * 编辑房型信息
     * @param name 房型名称
     * @param operatorName 操作人
     * @param roomTypeId 	房型Id（required）
     * @param roomTypeStatus 房型状态
     * @param token
     */
    OTAModule.prototype.updateRoomType = function (name, operatorName, roomTypeId, status, token) {
        return this.gatewayClient.editRoomType(name, operatorName, roomTypeId, status, token);
    };
    /**
     * 获取打包房间列表
     * @param buildingId 楼宇Id
     * @param page
     * @param roomName 	房名
     * @param roomNo 房号
     * @param roomTypeId 房型Id
     * @param rows
     */
    OTAModule.prototype.queryRoomList = function (buildingId, page, roomName, roomNo, roomTypeId, rows, token) {
        return this.gatewayClient.getRoomDockingList(buildingId, page, roomName, roomNo, roomTypeId, rows, token);
    };
    /**
     * 查询未打包房间列表
     * @param roomTypeId 渠道房型ID
     * @param token
     */
    OTAModule.prototype.queryUnbindRoomList = function (roomTypeId, token) {
        return this.gatewayClient.getUnpackagedRoomList(roomTypeId, token);
    };
    /**
     * 新增打包
     * @param createName 	创建人
     * @param roomIds 房间Id,e.g. "188,189"
     * @param roomTypeId 房型Id
     * @param token
     */
    OTAModule.prototype.addRoomsToRoomType = function (createName, roomIds, roomTypeId, token) {
        return this.gatewayClient.addRoomDocking(createName, roomIds, roomTypeId, token);
    };
    /**
     * 删除打包
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    OTAModule.prototype.removeRoomToRoomType = function (roomId, roomTypeId, updateName, token) {
        return this.gatewayClient.cancelRoomDocking(roomId, roomTypeId, updateName, token);
    };
    /**
     * 更换取信息房
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    OTAModule.prototype.activeRoomInfo = function (roomId, roomTypeId, updateName, token) {
        return this.gatewayClient.changeInfoRoomDocking(roomId, roomTypeId, updateName, token);
    };
    /**
     * 更换取价房
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    OTAModule.prototype.activeRoomPrice = function (roomId, roomTypeId, updateName, token) {
        return this.gatewayClient.changeRoomDocking(roomId, roomTypeId, updateName, token);
    };
    /**
     * 新增房型
     * @param channelHotelId 渠道门店Id
     * @param channelId 渠道Id
     * @param name 房型名称
     * @param operatorName 操作人
     * @param token
     */
    OTAModule.prototype.addRoomType = function (channelId, hotelId, name, operatorName, token) {
        return this.gatewayClient.addRoomType(hotelId, channelId, name, operatorName, token);
    };
    /**
     * 删除房型
     * @param channelId 渠道Id
     * @param operatorName 	操作人姓名
     * @param roomTypeId 	房型Id
     * @param hotelId xbed门店Id
     * @param token
     */
    OTAModule.prototype.removeRoomType = function (channelId, operatorName, roomTypeId, hotelId, token) {
        return this.gatewayClient.deleteRoomType(channelId, operatorName, roomTypeId, hotelId, token);
    };
    /**
     * 门店签约接口
     * @param hotelId
     * @param userName
     * @param email
     * @param phone
     */
    OTAModule.prototype.sendHotelSignApplying = function (hotelId, userName, email, phone, token) {
        return this.gatewayClient.sendHotelSignApplying(hotelId, userName, email, phone, token);
    };
    /////////////////////////////// 飞猪 //////////////////////////////////
    /**
     * 新增飞猪门店
     * @param channelId 渠道ID（必传）
     * @param channelHotelName	飞猪门店名称 (必传)
     * @param xbedHotelId 门店ID（必传）
     * @param operatorName 操作人姓名（必传）
     * @param token
     */
    OTAModule.prototype.addFeizhuChannelHotel = function (channelId, channelHotelName, xbedHotelId, operatorName, isDirectLink, token) {
        return this.gatewayClient.addFeizhuChannelHotel(channelId, channelHotelName, xbedHotelId, operatorName, isDirectLink, token);
    };
    /**
     * 查询飞猪门店列表
     * @param channelHotelId 门店ID（必传）
     * @param page 页数
     * @param rows 每页数据量
     * @param status 打包状态筛选条件（1已打包，0未打包）
     * @param token
     */
    OTAModule.prototype.queryFeizhuRoomTypeList = function (params, token) {
        return this.gatewayClient.queryFeizhuRoomTypeList(params, token);
    };
    /**
     * 重新匹配门店
     * @param channelHotelId 门店ID(必传)
     * @param operatorName 操作人帐号(必传)
     * @param token
     */
    OTAModule.prototype.matchChannelHotel = function (channelHotelId, operatorName, token) {
        return this.gatewayClient.matchChannelHotel(channelHotelId, operatorName, token);
    };
    /**
     * 修改门店名称
     * @param channelHotelId 门店ID
     * @param channelHotelName 门店名称
     * @param operatorName 操作人姓名
     * @param token
     */
    OTAModule.prototype.editChannelHotel = function (channelHotelId, channelHotelName, operatorName, token) {
        return this.gatewayClient.editChannelHotel(channelHotelId, channelHotelName, operatorName, token);
    };
    /**
     * 新增房型-飞猪
     * @param bedType 床型（必传）
     * @param bedTypeDesc 床型描述
     * @param bufferCount 缓存房量（必传）
     * @param name 房型名称（必传）
     * @param operatorName 操作人姓名（必传）
     * @param channelHotelId 门店Id（必传）
     * @param channelId 渠道ID（写死4）
     * @param ratePlanName 价格计划名称（必传）
     * @param token
     */
    OTAModule.prototype.matchRoomType = function (params, token) {
        return this.gatewayClient.matchRoomType(params, token);
    };
    /**
     * 修改缓存房量
     * @param bufferCount 缓存房量（必传）
     * @param operatorName 操作人（必传）
     * @param roomTypeId 房型ID（必传）
     * @param token
     */
    OTAModule.prototype.updateBufferCount = function (bufferCount, operatorName, roomTypeId, token) {
        return this.gatewayClient.updateBufferCount(bufferCount, operatorName, roomTypeId, token);
    };
    /**
     * 匹配房型
     * @param operatorName 操作人(必传)
     * @param ratePlanName 价格计划名称
     * @param roomTypeId 房型ID(必传)
     * @param token
     */
    OTAModule.prototype.syncRoomTypeForFz = function (params, token) {
        return this.gatewayClient.syncRoomTypeForFz(params, token);
    };
    /**
     * 重新匹配房型
     * @param operatorName 操作人(必传)
     * @param ratePlanName 价格计划名称
     * @param roomTypeId 房型ID(必传)
     * @param token
     */
    OTAModule.prototype.reSyncRoomTypeForFz = function (params, token) {
        return this.gatewayClient.reSyncRoomTypeForFz(params, token);
    };
    /**
     * 编辑feizhu房型名称
     * @param
     */
    OTAModule.prototype.editRoomTypeFeizhu = function (params, token) {
        return this.gatewayClient.editRoomTypeFeizhu(params, token);
    };
    /**
     * 修改销售状态
     * @param hotelId
     * @param saleStatusCode
     * @param token
     */
    OTAModule.prototype.changeSaleStatus = function (hotelId, saleStatusCode, token) {
        return this.gatewayClient.changeSaleStatus(hotelId, saleStatusCode, token);
    };
    return OTAModule;
}(gateway_module_1.GatewayModule));
exports.OTAModule = OTAModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/ota/index.js
// module id = 210
// module chunks = 44